// Auto-generated by scripts/sync-locales.ts — DO NOT EDIT MANUALLY
export const locales = ['en', 'ar'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'en'

export const localeDirections: Record<Locale, 'ltr' | 'rtl'> = {
  en: 'ltr',
  ar: 'rtl'
}

export const localesMeta = [
  { code: 'en', nameEn: 'English', nameNative: 'English', direction: 'ltr' as const },
  { code: 'ar', nameEn: 'Arabic', nameNative: 'العربية', direction: 'rtl' as const }
] as const
